module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_9006.b0386acb.png";